var React = require('react');

function IconPhase (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M64.5 928.2h65.8v-830H64.5v830zM194 331.1h691.4c5.5 0 10-4.5 10-10V220.6c0-5.5-4.5-10-10-10H194v120.5zm0 241.1h401.1c5.5 0 10-4.5 10-10V461.7c0-5.5-4.5-10-10-10H194v120.5zm0 241.1h756.4c5.5 0 10-4.5 10-10V702.8c0-5.5-4.5-10-10-10H194v120.5z"}));
}

IconPhase.displayName = "IconPhase";

IconPhase.defaultProps = {"viewBox":"0 0 1024 1024"};

module.exports = IconPhase;

IconPhase.default = IconPhase;
